export default "__VITE_PUBLIC_ASSET__08ce7088__"